// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ShaA","inner":"Form_inner__2x4YD","range":"Form_range__ACNCP","name":"Form_name__Rwgm6","actions":"Form_actions__3N4sp"};